<template>
  <scoped>
    <div class="modal">
      <div>
        <slot />
      </div>
    </div>
  </scoped>
</template>

<style scoped>
  .modal {
    align-items: center;
    backdrop-filter: blur(5px);
    background-color: transparent;
    display: flex;
    flex-wrap: wrap;
    height: 100vh;
    justify-content: center;
    left: 0;
    overflow: hidden;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 1;

    > div {
      background-color: var(--color-white);
      border-color: var(--theme-color-primary);
      border-radius: var(--border-radius-big);
      border-style: solid;
      border-width: var(--border-width-bold);
      max-height: 80vh;
      max-width: 80vw;
      overflow: auto;
      padding: 2em;
      z-index: 2;
    }
  }
</style>
